import {
  Dialog,
  DialogContent,
  DialogProps,
  SxProps,
  Theme,
} from "@mui/material";
import { APP_MODAL_MAX_WIDTH } from "./modalConstants";

type ModalProps = DialogProps & {
  sx?: SxProps<Theme>;
};

export const StyledModal = ({ children, ...rest }: ModalProps) => {
  return (
    <Dialog
      {...rest}
      fullWidth={true}
      disablePortal={false}
      disableScrollLock={true}
      BackdropProps={{
        sx: {
          zIndex: 1700,
        },
      }}
      sx={{
        zIndex: 1800,
        "& .MuiDialog-container": {
          zIndex: 1800,
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: "1rem",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 4px 16px",
          maxWidth: APP_MODAL_MAX_WIDTH,
          width: "100%",
          zIndex: 1800,
          maxHeight: { xs: "95vh", sm: "92vh", md: "95vh" },
          margin: { xs: "0.5rem", sm: "1rem" },
          overflow: "hidden",
        },
      }}
    >
      <DialogContent
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          padding: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          overflowY: "auto",
          overflowX: "hidden",
          maxHeight: { xs: "calc(95vh - 1rem)", sm: "calc(92vh - 2rem)", md: "calc(95vh - 2rem)" },
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        })}
        {...rest}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
